const style = (primary: string, secondary: string) =>
    `background: ${primary}; color: ${secondary}; display: block; font-weight: normal;`;

const tracer = {
    error: (msg?: string) => console.log(`%ce-conomic ⟹ %c ${msg} `, 'font-weight: bold;', style('#fd9292', '#000')),
    info: (msg?: string) => console.log(`%ce-conomic ⟹ %c ${msg} `, 'font-weight: bold;', style('#7fd3ff', '#000')),
    status: (msg?: string) => console.log(`%ce-conomic ⟹ %c ${msg} `, 'font-weight: bold;', style('#444', '#fff')),
    warn: (msg?: string) => console.log(`%ce-conomic ⟹ %c ${msg} `, 'font-weight: bold;', style('#ffd47f', '#000')),
    group: (msg?: string) => console.groupCollapsed(`%ce-conomic ⟹ %c ${msg} `, 'font-weight: bold;', style('#444', '#fff')),
    groupEnd: () => console.groupEnd(),
};

if (process.env.NODE_ENV !== 'development') {
    tracer.error = () => {};
    tracer.info = () => {};
    tracer.status = () => {};
    tracer.warn = () => {};
    tracer.group = () => {};
    tracer.groupEnd = () => {};
}

export default tracer;
